import { faPlaneDeparture, faPlusCircle, faStarShooting } from '@fortawesome/pro-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { useNavigate, useParams } from 'react-router'
import { useEffect } from 'react'

import { type OnboardingPage } from '../routes'
import useMe from '../../utils/useMe'
import { OnboardingTitle } from '../components/OnboardingTitle'
import { track } from '../../utils/analytics'

import { Card, CardContent, CardActions, Button } from '@olino/design-system'

const Main = () => {
  const { id } = useParams()
  const user = useMe()
  const navigate = useNavigate()

  useEffect(() => {
    track({
      event: 'visited_finalization',
      quotation_id: id,
    })
  }, [id])

  return (
    <>
      <OnboardingTitle.H1 className="mb-5">
        Nous ne pouvons malheureusement pas donner suite à votre demande.
      </OnboardingTitle.H1>

      <Card className="sm:pt-4">
        <CardContent>
          <div className="space-y-4 text-center text-sm sm:gap-6 md:grid-cols-2 md:flex-row md:space-y-0">
            <div className="flex flex-col items-center ">
              <p>
                Au vu des éléments que vous nous avez communiqués, nous ne disposons actuellement
                d'aucune solution d'assurance à vous proposer.
              </p>
              <p>
                <br />
                N'hésitez pas à visiter notre site internet et à nous solliciter pour d'autres
                demandes.
              </p>
            </div>
          </div>
        </CardContent>

        <CardActions>
          <div className="mt-3 flex flex-col items-center justify-center gap-6 sm:flex-row">
            <Button
              type="submit"
              onClick={() => (window.location.href = 'https://pilliot-assurances.com/')}
            >
              Découvrez notre site internet
            </Button>
          </div>
        </CardActions>
      </Card>
    </>
  )
}

const Tips = () => {
  return undefined
}

export default {
  main: <Main />,
  tips: <Tips />,
} satisfies OnboardingPage
